import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  Icon,
  InputLabel,
  Link,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { Field } from "formik";
import WDBox from "../../../../../MaterialComponents/WDBox";

import React from "react";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import pxToRem from "../../../../../Themes/Functions/pxToRem";
import WDButton from "../../../../../MaterialComponents/WDButton";
import { STAT_FIELDS } from "../../../../../Configurations/StatFieldData";
import AppService from "../../../../../Configurations/Appservice";

import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import tz from "dayjs/plugin/timezone";

const PDF = "PDF";
const IMAGE = "IMAGE";
const DOCUMENT = "DOCUMENT";

const CustomerStatFieldInfo = (props) => {
  dayjs.extend(utc);
  // dayjs.extend(utc);
  // dayjs.extend(tz);
  // dayjs.tz.setDefault("Asia/Kolkata");

  const {
    staticFields,
    isUidready,
    formikRef,
    setFieldValue,
    uploadingDocs,
    onUpload,
    onUploadComplete,
    formikValues,
  } = props;

  const onFileChange = async (event, formikField) => {
    const file = event.target.files[0];
    onUpload(formikField);

    const formData = new FormData();
    formData.append("file", file);

    const docUrl = await AppService.post("v1/files/upload", formData);
    setFieldValue(formikField, docUrl);
    onUploadComplete(formikField);
  };

  const ViewFileButton = ({ docUrl, formikField, disabled }) => {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        p={1}
        sx={{
          border: 1,
          borderColor: "grey.400",
          borderRadius: pxToRem(6),
          height: pxToRem(38),
        }}
      >
        <WDButton
          disabled={disabled}
          variant="text"
          component={Link}
          style={{ fontSize: "10px" }}
          target="_blank"
          href={docUrl}
          underline="hover"
        >
          View uploaded {STAT_FIELDS[formikField]?.label || formikField}
        </WDButton>
        <Icon fontSize="small" onClick={() => setFieldValue(formikField, null)}>
          delete
        </Icon>
      </Box>
    );
  };

  const FileUploadButton = ({ formikField, isLoading, disabled, fileType }) => {
    let acceptedType;
    if (fileType === PDF) {
      acceptedType = "application/pdf";
    } else if (acceptedType === IMAGE) {
      acceptedType = "image/*";
    }
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        p={1}
        sx={{
          border: 1,
          borderColor: "grey.400",
          borderRadius: pxToRem(6),
          height: pxToRem(38),
        }}
      >
        <WDButton
          disabled={isLoading || disabled}
          variant="text"
          component="label"
          style={{ fontSize: "10px" }}
        >
          Upload {STAT_FIELDS[formikField].label}
          <input
            type="file"
            hidden
            onChange={(event) => onFileChange(event, formikField)}
            accept={acceptedType}
          />
        </WDButton>
        {isLoading && <CircularProgress size={16} />}
      </Box>
    );
  };

  return (
    <WDBox my={2}>
      {staticFields.length && !isUidready ? (
        <Typography fontSize={10} color="red">
          ** Serach for uid details to make below fields active
        </Typography>
      ) : null}
      <Grid container spacing={1}>
        {staticFields.includes("firstNameEn") && (
          <Grid item xs={6} my={1}>
            <Field
              name="firstNameEn"
              label="First Name (English)"
              fullWidth
              as={TextField}
              size="small"
              disabled={!isUidready}
            />
          </Grid>
        )}
        {staticFields.includes("middleNameEn") && (
          <Grid item xs={6} my={1}>
            <Field
              name="middleNameEn"
              label="Middle Name (English)"
              fullWidth
              as={TextField}
              size="small"
              disabled={!isUidready}
            />
          </Grid>
        )}
        {staticFields.includes("lastNameEn") && (
          <Grid item xs={6} my={1}>
            <Field
              name="lastNameEn"
              label="Last Name (English)"
              fullWidth
              as={TextField}
              size="small"
              disabled={!isUidready}
            />
          </Grid>
        )}
        {staticFields.includes("firstNameAr") && (
          <Grid item xs={6} my={1}>
            <Field
              name="firstNameAr"
              label="Fist Name (Arabic)"
              fullWidth
              as={TextField}
              size="small"
              disabled={!isUidready}
            />
          </Grid>
        )}
        {staticFields.includes("middleNameAr") && (
          <Grid item xs={6} my={1}>
            <Field
              name="middleNameAr"
              label="Middile Name (Arabic)"
              fullWidth
              as={TextField}
              size="small"
              disabled={!isUidready}
            />
          </Grid>
        )}
        {staticFields.includes("lastNameAr") && (
          <Grid item xs={6} my={1}>
            <Field
              name="lastNameAr"
              label="Last Name (Arabic)"
              fullWidth
              as={TextField}
              size="small"
              disabled={!isUidready}
            />
          </Grid>
        )}
        {staticFields.includes("nameEn") && (
          <Grid item xs={6} my={1}>
            <Field
              name="nameEn"
              label="Name (English)"
              fullWidth
              as={TextField}
              size="small"
              disabled={!isUidready}
            />
          </Grid>
        )}
        {staticFields.includes("nameAr") && (
          <Grid item xs={6} my={1}>
            <Field
              name="nameAr"
              label="Name (Arabic)"
              fullWidth
              as={TextField}
              size="small"
              disabled={!isUidready}
            />
          </Grid>
        )}
        {staticFields.includes("dob") && (
          <Grid item xs={6} my={1}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer
                components={["DatePicker", "DatePicker"]}
                sx={{ position: "relative", top: -8 }}
              >
                <Field
                  name="dob"
                  as={DatePicker}
                  disabled={!isUidready}
                  format="DD-MM-YYYY"
                  label="Date Of Birth"
                  onChange={(newValue) => {
                    let formattedDate = dayjs.utc(newValue).local().format("YYYY-MM-DD");
                    setFieldValue("dob", dayjs.utc(formattedDate, "YYYY-MM-DD"));
                  }}
                  slotProps={{
                    textField: { fullWidth: true, size: "small" },
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>
          </Grid>
        )}
        {staticFields.includes("gender") && (
          <Grid item xs={6} my={1}>
            <FormControl fullWidth>
              <InputLabel id="gender-select-label">Gender</InputLabel>
              <Field
                labelId="gender-select-label"
                name="gender"
                label="Gender"
                fullWidth
                size="small"
                as={Select}
                disabled={!isUidready}
              >
                <MenuItem value="MALE">MALE</MenuItem>
                <MenuItem value="FEMALE">FEMALE</MenuItem>
              </Field>
            </FormControl>
          </Grid>
        )}
        {staticFields.includes("passportNumber") && (
          <Grid item xs={6} my={1}>
            <Field
              name="passportNumber"
              label="Passport Number"
              fullWidth
              as={TextField}
              size="small"
              disabled={!isUidready}
            />
          </Grid>
        )}
        {staticFields.includes("passportIssue") && (
          <Grid item xs={6} my={1}>
            <Field
              name="passportIssue"
              label="Passport Issue"
              fullWidth
              as={TextField}
              size="small"
              disabled={!isUidready}
            />
          </Grid>
        )}
        {staticFields.includes("passportExpiry") && (
          <Grid item xs={6} my={1}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer
                components={["DatePicker", "DatePicker"]}
                sx={{ position: "relative", top: -8 }}
              >
                <Field
                  name="passportExpiry"
                  as={DatePicker}
                  disabled={!isUidready}
                  format="DD-MM-YYYY"
                  label="Passport Expiry Date"
                  onChange={(newValue) => {
                    let formattedDate = dayjs.utc(newValue).local().format("YYYY-MM-DD");
                    setFieldValue("passportExpiry", dayjs.utc(formattedDate, "YYYY-MM-DD"));
                  }}
                  slotProps={{
                    textField: { fullWidth: true, size: "small" },
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>
          </Grid>
        )}
        {staticFields.includes("passportIssuePlaceEn") && (
          <Grid item xs={6} my={1}>
            <Field
              name="passportIssuePlaceEn"
              label="Passport Issued Place (English)"
              fullWidth
              as={TextField}
              size="small"
              disabled={!isUidready}
            />
          </Grid>
        )}
        {staticFields.includes("passportIssuePlaceAr") && (
          <Grid item xs={6} my={1}>
            <Field
              name="passportIssuePlaceAr"
              label="Passport Issued Place (Arabic)"
              fullWidth
              as={TextField}
              size="small"
              disabled={!isUidready}
            />
          </Grid>
        )}
        {staticFields.includes("emiratesId") && (
          <Grid item xs={6} my={1}>
            <Field
              name="emiratesId"
              label="Emirated Id"
              fullWidth
              as={TextField}
              size="small"
              disabled={!isUidready}
            />
          </Grid>
        )}
        {staticFields.includes("emiratesIdIssueDate") && (
          <Grid item xs={6} my={1}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer
                components={["DatePicker", "DatePicker"]}
                sx={{ position: "relative", top: -8 }}
              >
                <Field
                  name="emiratesIdIssueDate"
                  as={DatePicker}
                  disabled={!isUidready}
                  format="DD-MM-YYYY"
                  label="Emirates Id Issue Date"
                  onChange={(newValue) => {
                    let formattedDate = dayjs.utc(newValue).local().format("YYYY-MM-DD");
                    setFieldValue("emiratesIdIssueDate", dayjs.utc(formattedDate, "YYYY-MM-DD"));
                  }}
                  slotProps={{
                    textField: { fullWidth: true, size: "small" },
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>
          </Grid>
        )}
        {staticFields.includes("emiratesIdExpiryDate") && (
          <Grid item xs={6} my={1}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer
                components={["DatePicker", "DatePicker"]}
                sx={{ position: "relative", top: -8 }}
              >
                <Field
                  name="emiratesIdExpiryDate"
                  as={DatePicker}
                  disabled={!isUidready}
                  format="DD-MM-YYYY"
                  label="Emirates Id Expiry Date"
                  onChange={(newValue) => {
                    let formattedDate = dayjs.utc(newValue).local().format("YYYY-MM-DD");
                    setFieldValue("emiratesIdExpiryDate", dayjs.utc(formattedDate, "YYYY-MM-DD"));
                  }}
                  slotProps={{
                    textField: { fullWidth: true, size: "small" },
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>
          </Grid>
        )}
        {staticFields.includes("birthPlaceEn") && (
          <Grid item xs={6} my={1}>
            <Field
              name="birthPlaceEn"
              label="Birth Place (English)"
              fullWidth
              as={TextField}
              size="small"
              disabled={!isUidready}
            />
          </Grid>
        )}
        {staticFields.includes("birthPlaceAr") && (
          <Grid item xs={6} my={1}>
            <Field
              name="birthPlaceAr"
              label="Birth Place (Arabic)"
              fullWidth
              as={TextField}
              size="small"
              disabled={!isUidready}
            />
          </Grid>
        )}
        {staticFields.includes("birthCertificate") && (
          <Grid item xs={6} my={1}>
            {formikValues?.birthCertificate ? (
              <ViewFileButton
                formikField="birthCertificate"
                docUrl={formikValues.birthCertificate}
                disabled={!isUidready}
              />
            ) : (
              <FileUploadButton
                formikField="birthCertificate"
                isLoading={uploadingDocs.includes("birthCertificate")}
                disabled={!isUidready}
                fileType={PDF}
              />
            )}
          </Grid>
        )}
        {staticFields.includes("emirate") && (
          <Grid item xs={6} my={1}>
            <Field
              name="emirate"
              label="Emirate"
              fullWidth
              as={TextField}
              size="small"
              disabled={!isUidready}
            />
          </Grid>
        )}
        {staticFields.includes("address") && (
          <Grid item xs={6} my={1}>
            <Field
              name="address"
              label="Address"
              fullWidth
              as={TextField}
              size="small"
              disabled={!isUidready}
            />
          </Grid>
        )}
        {staticFields.includes("area") && (
          <Grid item xs={6} my={1}>
            <Field
              name="area"
              label="Area"
              fullWidth
              as={TextField}
              size="small"
              disabled={!isUidready}
            />
          </Grid>
        )}
        {staticFields.includes("buildingNumber") && (
          <Grid item xs={6} my={1}>
            <Field
              name="buildingNumber"
              label="Building Number"
              fullWidth
              as={TextField}
              size="small"
              disabled={!isUidready}
            />
          </Grid>
        )}
        {staticFields.includes("poBox") && (
          <Grid item xs={6} my={1}>
            <Field
              name="poBox"
              label="Po Box"
              fullWidth
              as={TextField}
              size="small"
              disabled={!isUidready}
            />
          </Grid>
        )}
        {staticFields.includes("mobileNumber") && (
          <Grid item xs={6} my={1}>
            <Field
              name="mobileNumber"
              label="Mobile Number"
              fullWidth
              as={TextField}
              size="small"
              disabled={!isUidready}
            />
          </Grid>
        )}
        {staticFields.includes("landNumber") && (
          <Grid item xs={6} my={1}>
            <Field
              name="landNumber"
              label="Land Number"
              fullWidth
              as={TextField}
              size="small"
              disabled={!isUidready}
            />
          </Grid>
        )}
        {staticFields.includes("deliveryNumber") && (
          <Grid item xs={6} my={1}>
            <Field
              name="deliveryNumber"
              label="Delivery Number"
              fullWidth
              as={TextField}
              size="small"
              disabled={!isUidready}
            />
          </Grid>
        )}
        {staticFields.includes("email") && (
          <Grid item xs={6} my={1}>
            <Field
              name="email"
              label="Email"
              fullWidth
              as={TextField}
              size="small"
              disabled={!isUidready}
            />
          </Grid>
        )}
        {staticFields.includes("fileNumber") && (
          <Grid item xs={6} my={1}>
            <Field
              name="fileNumber"
              label="File Number"
              fullWidth
              as={TextField}
              size="small"
              disabled={!isUidready}
            />
          </Grid>
        )}
        {staticFields.includes("passportCopy") && (
          <Grid item xs={6} my={1}>
            {formikValues?.passportCopy ? (
              <ViewFileButton
                formikField="passportCopy"
                docUrl={formikValues.passportCopy}
                disabled={!isUidready}
              />
            ) : (
              <FileUploadButton
                formikField="passportCopy"
                isLoading={uploadingDocs.includes("passportCopy")}
                disabled={!isUidready}
                fileType={PDF}
              />
            )}
          </Grid>
        )}
        {staticFields.includes("visaPage") && (
          <Grid item xs={6} my={1}>
            {formikValues?.visaPage ? (
              <ViewFileButton
                formikField="visaPage"
                docUrl={formikValues.visaPage}
                disabled={!isUidready}
                fileType={PDF}
              />
            ) : (
              <FileUploadButton
                formikField="visaPage"
                isLoading={uploadingDocs.includes("visaPage")}
                disabled={!isUidready}
                fileType={PDF}
              />
            )}
          </Grid>
        )}
        {staticFields.includes("visaIssueDate") && (
          <Grid item xs={6} my={1}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer
                components={["DatePicker", "DatePicker"]}
                sx={{ position: "relative", top: -8 }}
              >
                <Field
                  name="visaIssueDate"
                  as={DatePicker}
                  disabled={!isUidready}
                  format="DD-MM-YYYY"
                  label="Visa Issue Date"
                  onChange={(newValue) => {
                    let formattedDate = dayjs.utc(newValue).local().format("YYYY-MM-DD");
                    setFieldValue("visaIssueDate", dayjs.utc(formattedDate, "YYYY-MM-DD"));
                  }}
                  slotProps={{
                    textField: { fullWidth: true },
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>
          </Grid>
        )}
        {staticFields.includes("visaExpiryDate") && (
          <Grid item xs={6} my={1}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer
                components={["DatePicker", "DatePicker"]}
                sx={{ position: "relative", top: -8 }}
              >
                <Field
                  name="visaExpiryDate"
                  as={DatePicker}
                  disabled={!isUidready}
                  format="DD-MM-YYYY"
                  label="Visa Expiry Date"
                  onChange={(newValue) => {
                    let formattedDate = dayjs.utc(newValue).local().format("YYYY-MM-DD");
                    setFieldValue("visaExpiryDate", dayjs.utc(formattedDate, "YYYY-MM-DD"));
                  }}
                  slotProps={{
                    textField: { fullWidth: true },
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>
          </Grid>
        )}
        {staticFields.includes("photo") && (
          <Grid item xs={6} my={1}>
            {formikValues?.photo ? (
              <ViewFileButton
                formikField="photo"
                docUrl={formikValues.photo}
                disabled={!isUidready}
                fileType={IMAGE}
              />
            ) : (
              <FileUploadButton
                formikField="photo"
                isLoading={uploadingDocs.includes("photo")}
                disabled={!isUidready}
              />
            )}
          </Grid>
        )}
        {staticFields.includes("shinasnama") && (
          <Grid item xs={6} my={1}>
            {formikValues?.shinasnama ? (
              <ViewFileButton
                formikField="shinasnama"
                docUrl={formikValues.shinasnama}
                disabled={!isUidready}
              />
            ) : (
              <FileUploadButton
                formikField="shinasnama"
                isLoading={uploadingDocs.includes("shinasnama")}
                disabled={!isUidready}
                fileType={PDF}
              />
            )}
          </Grid>
        )}
        {staticFields.includes("labourContract") && (
          <Grid item xs={6} my={1}>
            {formikValues?.labourContract ? (
              <ViewFileButton
                formikField="labourContract"
                docUrl={formikValues.labourContract}
                disabled={!isUidready}
              />
            ) : (
              <FileUploadButton
                formikField="labourContract"
                isLoading={uploadingDocs.includes("labourContract")}
                disabled={!isUidready}
                fileType={PDF}
              />
            )}
          </Grid>
        )}
        {staticFields.includes("salaryCertificate") && (
          <Grid item xs={6} my={1}>
            {formikValues?.salaryCertificate ? (
              <ViewFileButton
                formikField="salaryCertificate"
                docUrl={formikValues.salaryCertificate}
                disabled={!isUidready}
              />
            ) : (
              <FileUploadButton
                formikField="salaryCertificate"
                isLoading={uploadingDocs.includes("salaryCertificate")}
                disabled={!isUidready}
                fileType={PDF}
              />
            )}
          </Grid>
        )}
      </Grid>
    </WDBox>
  );
};

export default CustomerStatFieldInfo;
